import React from 'react'
import { NotificationsWithMore } from './Notifications'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import Resx from '@/components/Resx'

class NotificationList extends React.Component {
  render () {
    return (
      <Main className='notifications' path={[{ text: 'NotificationsUI.WidgetTitle' }]}>
        <MainTop>
          <MainTopTitle>
            <Resx name='NotificationsUI.WidgetTitle' />
          </MainTopTitle>
        </MainTop>
        <MainBody>
          <NotificationsWithMore />
        </MainBody>
      </Main>
    )
  }
}

export default NotificationList



// WEBPACK FOOTER //
// ./src/components/notifications/list.js